<template>
    <CardContentPanel icon="graph" v-bind="{action, index}">
        <template #title="{freelancerName, month}">
            {{ $t('projectclient.projectview.activity.pending.actions.REVIEW_ACTIVITY_REPORT.title', {0: freelancerName, 1: month}) }}
        </template>
        <template #body="{freelancerName}">
            {{ $t('projectclient.projectview.activity.pending.actions.REVIEW_ACTIVITY_REPORT.description', {0: freelancerName}) }}
        </template>
        <template #actions>
            <NuxtLink
                :to="`/project/${projectInformation.projectId}/validation?lotId=${action.extraData.lotId}&origin=project-view`"
                data-testid="pending-action-card-cta-primary"
            >
                <VJoyButton variant="main" size="small">
                    {{ $t('projectclient.projectview.activity.pending.actions.REVIEW_ACTIVITY_REPORT.action.primary') }}
                </VJoyButton>
            </NuxtLink>
        </template>
    </CardContentPanel>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyButton} from '@maltjoy/core-vue';
    import CardContentPanel from '../CardContentPanel.vue';
    import {useProjectInformationStore} from '@/common/stores';
    import type {ActivityPendingActionByType} from '@/features/project-view';

    defineProps<{
        action: ActivityPendingActionByType<'REVIEW_ACTIVITY_REPORT'>;
        index: number;
    }>();

    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);
</script>
